export const areQueriesDone = queries => {
  const done = queries.filter(q => q.isLoading)
  return done.length === 0
}


